import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import api from "../../services/baseUrl";
import CircularProgress from "@mui/material/CircularProgress";
import {
  TiArrowSortedDown,
  TiArrowSortedUp,
  TiArrowRight,
  TiArrowUp,
  TiArrowUnsorted,
  TiTrash
} from "react-icons/ti";

export default function InboxNotification() {
  // const cookie = Cookies.get("user") || sessionStorage.getItem("user");
  const cookie = sessionStorage.getItem("user");
  const user = JSON.parse(cookie).user;
  const [inboxContent, setInboxContent] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [expandedMessages, setExpandedMessages] = useState({});
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });

  useEffect(() => {
    setLoading(true);
    

    fetchInboxNotification();
  }, [user.userName]);

  const fetchInboxNotification = async () => {
      setLoading(true);
      try {
        const response = await api.get("/notification/subscriber/get", {
          params: { username: user.userName },
        });

      setInboxContent(response.data);
      console.log("Response - " + response);
      console.log("Response.data = " + response.data);
      console.log("Response.data first element = " + response.data[0]);
      console.log("Response.data first element message = " + response.data[0].message);
        console.log("Fectching Inbox completed!!!!!!!!!!!", inboxContent);

      } catch (error) {
        console.error(
          "Error fetching bookmarks:",
          error.response?.data || error.message
        );
      } finally {
        setLoading(false);
      }
    };

  const handleSort = (key) => {
    
  };
  
  const getArrowIcon = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "asc" ? (
        <TiArrowSortedUp size={18} className="case-law-arrow-up" />
      ) : (
        <TiArrowSortedDown size={18} className="case-law-arrow-down" />
      );
    } else {
      return <TiArrowUnsorted size={18} />;
    }
  };

  const formatDate = (dateString) => {
    const dateObj = new Date(dateString);
    return dateObj.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };

  const formatTime = (timeString) => {
    const dateObj = new Date(timeString);
    return dateObj.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true, // Ensures AM/PM format
    }).toLowerCase(); // Optional: makes 'AM/PM' lowercase
  };

  const handleCheckboxChange = (id) => {
    setSelectedUsers((prev) =>
      prev.includes(id) ? prev.filter((userId) => userId !== id) : [...prev, id]
    );
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedUsers(inboxContent.map((u) => u.id)); // Select all IDs
    } else {
      setSelectedUsers([]); // Deselect all
    }
  };

  const handleDelete = async (id) => {
    setLoading(true);
    try {
      const response = await api.delete("/notification/subsriber/remove/" + id);

      console.log("Delete Response - " + response);
      alert("Selected notification removed successfully!!!");
      fetchInboxNotification();
    } catch (error) {
      console.error(
        "Error fetching bookmarks:",
        error.response?.data || error.message
      );
      alert("An error occurred while deleting the notification. Please try again after sometime.");
    } finally {
      setLoading(false);
    }
  };

  // Expand/Collapse handler
  const toggleExpand = (id) => {
    setExpandedMessages((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const allSelected = selectedUsers.length === inboxContent.length;

  return (
    <div style={{ padding: "25px", display: "flex", gap: "20px" }}>
      <div className="safety-one-table">
        <h2>Inbox {"("}{inboxContent.length}{")"}</h2><br/>
        {loading ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: 40,
                        }}
                      >
                        <CircularProgress />
                      </div>
                    ) : (
                <div>

                <table border="0" style={{
                  width: "100%",
                paddingBottom: "0.75rem",
                marginBottom: "0.75rem",
                gap: "10px",
                borderBottom: "1px solid #ddd", // 👈 horizontal divider
              }}>
                <tr>
                  <td>&nbsp;</td>
                  <td align="center" colspan = "2">
                    
                <label>
                  <strong>Select All</strong><br/>
                  <input
                    type="checkbox"
                    checked={allSelected}
                    onChange={handleSelectAll}
                  />
                </label>
                  </td>
                </tr>
                  {inboxContent.map((result) => {
                    //result.message = "This is a longer message that goes beyond five hundred characters so it should show an arrow to expand and collapse. This is a longer message that goes beyond five hundred characters so it should show an arrow to expand and collapse. This is a longer message that goes beyond five hundred characters so it should show an arrow to expand and collapse. This is a longer message that goes beyond five hundred characters so it should show an arrow to expand and collapse. This is a longer message that goes beyond five hundred characters so it should show an arrow to expand and collapse. This is a longer message that goes beyond five hundred characters so it should show an arrow to expand and collapse. This is a longer message that goes beyond five hundred characters so it should show an arrow to expand and collapse. This is a longer message that goes beyond five hundred characters so it should show an arrow to expand and collapse. ";
                    const maxCharacters = 150;
                    const isExpanded = expandedMessages[result.id];
                    const showToggle = result.message.length > maxCharacters;
                    const displayMessage = isExpanded
                                              ? result.message
                                              : showToggle
                                              ? result.message.slice(0, maxCharacters) + "..."
                                              : result.message;
                                              return (
                    <tr>
                      <td>
                        | &nbsp; {formatDate(result.dateCreated)} &nbsp; | &nbsp; {formatTime(result.dateCreated)}<br/><br/>
                        <p>{displayMessage}
                        {showToggle && (
                    <button
                      onClick={() => toggleExpand(result.id)}
                      style={{
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        fontSize: "0.9rem",
                        marginLeft: "4px",
                        verticalAlign: "middle"
                      }}
                      title={isExpanded ? "Collapse" : "Expand"}
                    >
                      {isExpanded ? <span style={{ color: "#4994EB", fontSize: "24px", fontWeight: "bold" }}>{'^'}</span> : <span style={{ color: "#4994EB", fontSize: "24px", fontWeight: "bold" }}>{'>'}</span>}
                    </button>
                  )}</p>
                      </td>
                      <td align="right" width="40px">
                        <input
                          type="checkbox"
                          checked={selectedUsers.includes(result.id)}
                          onChange={() => handleCheckboxChange(result.id)}
                        />
                      </td>
                      <td align="right" width="30px">
                        <button
                          onClick={() => handleDelete(result.id)}
                          style={{
                            background: "none",
                            border: "none",
                            color: "red",
                            cursor: "pointer",
                            fontSize: "1.1rem",
                          }}
                          title="Delete user"
                        >
                          <TiTrash size={25} color="#4994EB" />
                        </button>
                      </td>
                    </tr>
                  )})}
                </table>
                </div>
            )}
      </div>
    </div>
  );
}
